<template>
  <b-row>
    <b-col>
      <h6 class="compo-heading">Payment Terms</h6>
    </b-col>
  </b-row>
  <div class="details-card">
    <b-row>
      <b-col lg="12" md="12" sm="12" cols="12">
        <div class="field">
          <Dropdown
            name="Payterms"
            id="Payterms"
            :label="$t('5005.paymentterms.terms')"
            :rules="{ required: true }"
            :required-icon="true"
            :items="paymenttermsdd"
            v-model="paymentterms.PayTermsId"
            @change="input"
          />
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="6" md="6" sm="12" cols="12">
        <div class="field">
          <TextInput
            name="creditperiod"
            id="creditperiod"
            :label="$t('5005.paymentterms.creditperiod')"
            :rules="{ required: true, numeric: true }"
            :required-icon="true"
            v-model="paymentterms.CreditPeriod"
            @change="input"
          />
        </div>
      </b-col>
      <b-col lg="6" md="6" sm="12" cols="12">
        <div class="field">
          <Datepicker
            v-model="paymentterms.DateOfAssociation"
            :label="$t('5005.paymentterms.doassociation')"
            :name="$t('5005.paymentterms.doassociation')"
            :id="$t('5005.paymentterms.doassociation')"
          />
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="6" md="6" sm="12" cols="12">
        <div class="field">
          <TextInput
            name="discount"
            id="discount"
            :label="$t('5005.paymentterms.discount')"
            :rules="{ required: true, decimalnumeric: true }"
            :required-icon="true"
            v-model="paymentterms.DiscountPer"
            @change="input"
          />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, reactive, toRefs, onMounted } from "vue";
import service from "../../Service/SupplierMaster";
import Datepicker from "../../../../components/FormComponents/DatePicker.vue";
import TextInput from "../../../../components/FormComponents/TextInput.vue";
import Dropdown from "../../../../components/FormComponents/Dropdown.vue";

export default defineComponent({
  components: {
    Dropdown,
    Datepicker,
    TextInput,
  },

  props: {
    value: {},
  },

  setup(props, { emit }) {
    //Session Hospital&Branch ID
    let session: any = localStorage.getItem("UsersData");

    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);

    const paymentterms = reactive({
      PayTermsId: "",
      CreditPeriod: "",
      DateOfAssociation: "",
      DiscountPer: "",
    });

    onMounted(() => {
      PaymentTermsServicedd();

      Object.assign(paymentterms, props.value);

      input();
    });

    function input() {
      debugger;
      emit("update:modelValue", paymentterms);
    }

    // dropdown api for payment terms

    let paymenttermsdd = ref();

    async function PaymentTermsServicedd() {
      try {
        const dataresponse = await service.getpaymentstermsdd();

        console.log(dataresponse["result"]);

        paymenttermsdd.value = dataresponse["result"]
          .filter(
            (items) =>
              items.HospitalId == HospitalId && items.BranchId == BranchId
          )
          .map((item) => {
            item.name = item.PaymentTermsDesc;
            item.value = item.Id;
            return item;
          });

        input();
      } catch (error) {
        alert(error);
      }
    }

    return {
      input,
      paymentterms,
      paymenttermsdd,
      PaymentTermsServicedd,
    };
  },
});
</script>
